import { topicsData } from '@/mocks/homeData';

export default function TopicsSection() {
  const scrollTo = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-4xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">热门话题</h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">全网热议的综艺话题，加入讨论发现更多精彩</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topicsData.map((topic, i) => (
            <button
              key={i}
              onClick={() => scrollTo('#cards')}
              className="group px-5 py-3 bg-background-50 border border-background-200/70 rounded-xl hover:border-primary-300 hover:bg-primary-50/30 transition-all duration-300 cursor-pointer"
            >
              <span className="font-heading text-base font-bold text-foreground-800 group-hover:text-primary-600 transition-colors block">{topic.name}</span>
              <span className="text-xs text-foreground-400 mt-1 block">{topic.heat}</span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}